import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";
import {AuthenticationService} from "../services/authentication.service";
import Swal from "sweetalert2";
import {User} from "../models/User";
import {Role} from "../models/Role";

@Component({
  selector: 'app-secure-code',
  templateUrl: './secure-code.component.html',
  styleUrls: ['./secure-code.component.scss'],
})
export class SecureCodeComponent implements OnInit {
  codeForm!: FormGroup;
  loading = false;
  email!: string;
  currentUser: User;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService
  ) {
    this.currentUser = {} as User;
    this.authenticationService.currentUser.subscribe(x => this.currentUser = x || {} as User);
  }

  ngOnInit() {
    this.email = this.route.snapshot.queryParams['email'] || '';
    this.codeForm = this.formBuilder.group({
      code: ['', Validators.required],
    });

    // Ensure currentUser updates properly
    this.authenticationService.currentUser.subscribe(x => this.currentUser = x || {} as User);
  }

  onVerifyCode() {
    if (this.codeForm.invalid) {
      return;
    }

    this.loading = true;

    this.authenticationService.verifySecureCode(this.email, this.codeForm.value.code)
      .subscribe(
        (user) => { // Receive the updated user data
          this.loading = false;

          // Set the updated user
          this.currentUser = user;

          // Ensure roles are available before redirecting
          if (this.currentUser.roles.includes(Role.Admin)) {
            this.router.navigate(['/admin-panel/admin-dashboard']);
          } else if (this.currentUser.roles.includes(Role.User)) {
            this.router.navigate(['/editor-panel/editor-news']);
          } else if (this.currentUser.roles.includes(Role.Coach)) {
            this.router.navigate(['/admin-panel/admin-coach-applications']);
          } else {
            this.router.navigate(['/']);
          }
        },
        (error: any) => {
          const errorMessage = error?.error?.error || 'Invalid code. Please try again.';
          Swal.fire({
            title: 'Error',
            text: errorMessage,
            icon: 'error',
            confirmButtonText: 'OK',
          }).then(() => {
            this.loading = false;
          });
        }
      );
  }

}
